import { render, staticRenderFns } from "./EditOrderForm.vue?vue&type=template&id=51ffebf8&"
import script from "./EditOrderForm.vue?vue&type=script&lang=js&"
export * from "./EditOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports